import { render, staticRenderFns } from "./gift-card.vue?vue&type=template&id=2bf46980&scoped=true&"
import script from "./gift-card.vue?vue&type=script&lang=js&"
export * from "./gift-card.vue?vue&type=script&lang=js&"
import style0 from "./gift-card.vue?vue&type=style&index=0&id=2bf46980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf46980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf46980')) {
      api.createRecord('2bf46980', component.options)
    } else {
      api.reload('2bf46980', component.options)
    }
    module.hot.accept("./gift-card.vue?vue&type=template&id=2bf46980&scoped=true&", function () {
      api.rerender('2bf46980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/gift-card.vue"
export default component.exports